import './app';
import './forecast/check/forecastBettingArea';
import './forecast/table/forecastBettingArea';
import './horseRacesUI';
import './horseRacesUiService';
import './racecardBettingArea';
import './tricastBettingArea';

export default 'terminalApp.nabHorseRacesUi';
